var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.mainLoadingShow)?_c('rotate-square2'):_vm._e(),_vm._v(" "),_c('notifications'),_vm._v(" "),_c('span',{staticClass:"title indigo--text"},[_vm._v("Mohon menunggu... sedang merekontruksi aplikasi... ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50fa91f2","hasScoped":true,"transformToRequire":{"video":["src_suopass","poster"],"source":"src_suopass","img":"src_suopass","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src_suopass/Boot.vue
// module id = null
// module chunks = 